import { Redirect } from "react-router-dom";
import React from "react";

const ProtectedRoute = ({ isLoggedIn, children }) => {
  if (!isLoggedIn) {
    return <Redirect to="/" replace />;
  }
  return children;
};
export default ProtectedRoute;



// WEBPACK FOOTER //
// ./src/components/ProtectedRoute.jsx